import type { Product } from "../types/product";

const CDN = "https://cdn.shopify.com/s/files/1/0961/2060/2951/files/";
const lampColors = ["Wit", "Beige", "Lichtblauw", "Rood", "Oranje"];
const lampSpecs = [
  { label: "Kap", value: "ca. 24 × 25 cm, PLA" },
  { label: "Voet", value: "Creative-Cables Posaluce, metaal" },
  { label: "Fitting", value: "E27 — LED 2200K–2700K aanbevolen" },
  { label: "Snoer", value: "Textielsnoer ca. 2 m met schakelaar" },
];
const miniSpecs = [
  { label: "Formaat", value: "ca. Ø 15 × 14 cm" },
  { label: "Voeding", value: "Veilige 5V USB" },
  { label: "Licht", value: "Geïntegreerde warme LED" },
  { label: "Materiaal", value: "PLA, gemaakt in Nederland" },
];

export const products: Product[] = [
  {
    id: "koraal",
    name: "Koraal",
    title: "Design tafellamp met koraalstructuur",
    price: 129,
    category: "Verlichting",
    type: "Tafellamp",
    image: `${CDN}koraal-design-tafellamp-wit-aan.jpg?v=1786455614`,
    imageAlt: "Witte Koraal organische design tafellamp ingeschakeld met warm sfeervol licht.",
    description:
      "Geïnspireerd op de grillige vormen van koraal. Het warme licht schijnt door de openingen tussen de organische lijnen en zorgt voor een sfeervol spel van licht, schaduw en diepte.",
    specs: [{ label: "Kap", value: "ca. 25 × 25 cm, PLA" }, ...lampSpecs.slice(1)],
    colors: lampColors,
    badge: "Nieuw",
  },
  {
    id: "dune",
    name: "Dune",
    title: "Organische tafellamp met golvend reliëf",
    price: 129,
    category: "Verlichting",
    type: "Tafellamp",
    image: `${CDN}01_ed9a749c-451c-4e02-bdb6-e51b91d3aa09.jpg?v=1780847951`,
    imageAlt: "Dune sfeerlamp met golvende reliëflijnen in warm witte kap.",
    description:
      "Geïnspireerd op de zachte, vloeiende lijnen van zandduinen. Het golvende reliëf loopt rondom de kap en geeft Dune een sculpturale uitstraling — overdag én 's avonds.",
    specs: lampSpecs,
    colors: ["Warm wit"],
    badge: "Bestseller",
  },
  {
    id: "flow",
    name: "Flow",
    title: "Japandi sfeerlamp voor modern interieur",
    price: 129,
    category: "Verlichting",
    type: "Tafellamp",
    image: `${CDN}05.jpg?v=1780849816`,
    imageAlt: "Organische design tafellamp Flow op een dressoir.",
    description:
      "Geïnspireerd op vloeiende bewegingen uit de natuur. Laag voor laag geprint, waardoor organische vormen ontstaan die met traditionele technieken nauwelijks te maken zijn.",
    specs: lampSpecs,
    colors: ["Warm wit"],
  },
  {
    id: "bloom",
    name: "Bloom",
    title: "Tafellamp met gelaagde organische vormen",
    price: 129,
    category: "Verlichting",
    type: "Tafellamp",
    image: `${CDN}bloom-design-tafellamp-warm-licht.jpg?v=1786461474`,
    imageAlt: "Bloom design tafellamp met gelaagde organische vormen en warm licht.",
    description:
      "Zachte, golvende lagen openen zich rond de lichtbron. Het warme licht schijnt subtiel tussen de lagen door en geeft de vorm diepte zonder druk te worden.",
    specs: lampSpecs,
    colors: lampColors,
  },
  {
    id: "river",
    name: "River",
    title: "Tafellamp met vloeiend reliëf",
    price: 129,
    category: "Verlichting",
    type: "Tafellamp",
    image: `${CDN}river-design-tafellamp-woonkamer-sfeer.jpg?v=1786459073`,
    imageAlt: "River design tafellamp als sfeerverlichting op een salontafel.",
    description:
      "Een vloeiend reliëf dat doet denken aan stromend water en natuurlijke contourlijnen. Rustig en modern, met een zachte gloed die het patroon extra diepte geeft.",
    specs: lampSpecs,
    colors: lampColors,
  },
  {
    id: "tide",
    name: "Tide",
    title: "Sculpturale sfeerlamp met organisch reliëf",
    price: 129,
    category: "Verlichting",
    type: "Tafellamp",
    image: `${CDN}tide-sculpturale-sfeerlamp-warm-licht.jpg?v=1786460556`,
    imageAlt: "Tide sculpturale sfeerlamp met organisch reliëf en warm licht.",
    description:
      "Een rijk, gelaagd oppervlak dat doet denken aan een onderwaterlandschap. Brandend verandert het reliëf in een warm spel van licht en schaduw.",
    specs: lampSpecs,
    colors: lampColors,
  },
  {
    id: "lava",
    name: "Lava",
    title: "Japandi tafellamp met organische openingen",
    price: 129,
    category: "Verlichting",
    type: "Tafellamp",
    image: `${CDN}Witte_Lava_Sculpted_designlamp.jpg?v=1782223925`,
    imageAlt: "Witte Lava designlamp met ronde vorm en gelaagde organische openingen.",
    description:
      "Vloeiende openingen en gelaagde rondingen. Overdag een opvallend designobject; zodra de lamp aangaat komt de vorm volledig tot leven.",
    specs: lampSpecs,
    colors: ["Warm wit"],
  },
  {
    id: "ocean-wave",
    name: "Ocean Wave",
    title: "Golvende sfeerlamp met warm licht",
    price: 44,
    category: "Verlichting",
    type: "Sfeerlamp",
    image: `${CDN}01.jpg?v=1780516737`,
    imageAlt: "Ocean Wave sfeerlamp met warme LED-gloed en organische golfvorm.",
    description:
      "Geïnspireerd op de sierlijke plooien van zeeschelpen. Compact genoeg voor bureau of nachtkastje, met een zacht en diffuus licht.",
    specs: [
      { label: "Formaat", value: "14,8 × 13 cm" },
      { label: "Licht", value: "Warm, diffuus" },
      { label: "Serie", value: "Shell Series" },
    ],
  },
  {
    id: "atoll",
    name: "Atoll",
    title: "Mini sfeerlamp met koraalstructuur",
    price: 39,
    category: "Verlichting",
    type: "Mini lamp",
    image: `${CDN}atoll-mini-sfeerlamp-koraalstructuur-warm-licht.jpg?v=1786463600`,
    imageAlt: "Atoll mini design sfeerlamp met gelaagde koraalstructuur.",
    description:
      "Een compacte lamp met een gelaagde koraalstructuur, geïnspireerd op plaatkoraal en rifformaties. Werkt op veilige USB-voeding.",
    specs: miniSpecs,
    colors: lampColors,
  },
  {
    id: "strata",
    name: "Strata",
    title: "Mini designlamp met gelaagde structuur",
    price: 39,
    category: "Verlichting",
    type: "Mini lamp",
    image: `${CDN}strata-usb-mini-designlamp-warm-licht.jpg?v=1786462955`,
    imageAlt: "Strata USB mini designlamp met gelaagde structuur en warm licht.",
    description:
      "Verspringende horizontale lagen, als door erosie gevormde aardlagen. Van binnenuit verlicht met een zachte, warme gloed.",
    specs: miniSpecs,
    colors: lampColors,
  },
  {
    id: "sazanami",
    name: "Sazanami",
    title: "Japandi designvaas, 34 cm",
    price: 45,
    priceFrom: true,
    category: "Woondecoratie",
    type: "Vaas",
    image: `${CDN}Sazanami_Japandi.jpg?v=1786376165`,
    imageAlt: "Sazanami vaas als moderne woondecoratie met droogbloemen.",
    description:
      "Sazanami betekent 'kleine rimpelingen op het water'. Een golvende structuur loopt rondom de vaas; licht en schaduw veranderen gedurende de dag over het oppervlak.",
    specs: [
      { label: "Formaat", value: "ca. 34 × 14 cm" },
      { label: "Uitvoering", value: "Design 24 of 25" },
      { label: "Gebruik", value: "Droogbloemen, niet waterdicht" },
    ],
  },
  {
    id: "aurelia",
    name: "Aurelia",
    title: "Design vaas — moderne woondecoratie",
    price: 22.5,
    priceFrom: true,
    category: "Woondecoratie",
    type: "Vaas",
    image: `${CDN}preview_images/21b2755ed93f4a90a9c43ba1ade9f35a.thumbnail.0000000000.jpg?v=1781465067`,
    imageAlt: "Design vaas Aurelia met organische lijnen.",
    description:
      "Een organische vorm met vloeiende lijnen en subtiele glans. Verkrijgbaar in meerdere kleuren, ideaal voor droog- of kunstbloemen.",
    specs: [
      { label: "Formaat", value: "ca. 29 × 14 × 14 cm" },
      { label: "Materiaal", value: "PLA" },
    ],
  },
  {
    id: "lelievaas",
    name: "Lelievaas",
    title: "Unieke lelievaas in blauw metallic",
    price: 21,
    category: "Woondecoratie",
    type: "Vaas",
    image: `${CDN}20260415_153817.jpg?v=1782316117`,
    imageAlt: "Unieke lelievaas met gelaagd reliëf in blauw-metaalachtige kleur.",
    description:
      "Een sculpturale, organische vorm met verfijnd gelaagd reliëf. De diepe blauw-metaalachtige kleur geeft het ontwerp een luxe, moderne uitstraling.",
    specs: [
      { label: "Formaat", value: "ca. 20 × 23 cm" },
      { label: "Productie", value: "Lokaal 3D-geprint" },
    ],
    badge: "Uniek",
  },
  {
    id: "hiphop-eend",
    name: "Hip-hop eend",
    title: "Decoratiebeeld met boombox",
    price: 55,
    category: "Woondecoratie",
    type: "Decoratiebeeld",
    image: `${CDN}hiphop-eend-decoratiebeeld-boombox.png?v=1789321510`,
    imageAlt: "Hip-hop eend decoratiebeeld met pet, zonnebril en boombox.",
    description:
      "Een stoer decoratiebeeld met pet, zonnebril, ketting en grote boombox. Voor de mancave, gamekamer, muziekkamer of verzamelplank.",
    specs: [
      { label: "Materiaal", value: "PLA" },
      { label: "Gewicht", value: "ca. 1,4 kg" },
    ],
  },
  {
    id: "lithophane",
    name: "Fotolamp",
    title: "Gepersonaliseerde fotolamp met eigen foto",
    price: 23,
    category: "Gepersonaliseerd",
    type: "Lithophane",
    image: `${CDN}lithophane_fotolamp.webp?v=1783014102`,
    imageAlt: "Verlichte lithophane fotolamp met foto van een hond tussen witte bloemen.",
    description:
      "Jouw foto wordt omgezet in een reliëfafbeelding. Uit zie je het subtiele reliëf; zodra het licht aangaat, komt de foto echt tot leven.",
    specs: [
      { label: "Formaat", value: "gem. ca. 20 × 10 cm" },
      { label: "Licht", value: "5V LED, omkasting inbegrepen" },
    ],
    personalizable: true,
    personalization: "photo",
  },
  {
    id: "naamcirkel",
    name: "Naamcirkel",
    title: "Gepersonaliseerde naamcirkel met bloemen",
    price: 39.95,
    category: "Gepersonaliseerd",
    type: "Wanddecoratie",
    image: `${CDN}gepersonaliseerde-naamcirkel-bloemen-30-cm.png?v=1789733244`,
    imageAlt: "Naamcirkel van hout en transparant acrylaat met bloemenprint en naam.",
    description:
      "Licht berken en donker noten multiplex met transparant acrylaat. De naam vormt het middelpunt, gecombineerd met een botanische bloemenprint.",
    specs: [
      { label: "Formaat", value: "Ø ca. 30 cm" },
      { label: "Materiaal", value: "Multiplex & acrylaat" },
    ],
    personalizable: true,
    personalization: "text",
  },
  {
    id: "fotolamp-zw",
    name: "Fotolamp zwart/wit",
    title: "Fotolamp met eigen foto in zwart/wit",
    price: 21,
    category: "Gepersonaliseerd",
    type: "Lithophane",
    image: `${CDN}fotolichtbak1.jpg?v=1784278540`,
    imageAlt: "Gepersonaliseerde fotolamp met eigen foto in zwart/wit.",
    description:
      "Een dierbare foto als warme lichtdecoratie. Wij controleren je foto vooraf en nemen contact op als er iets onduidelijk is.",
    specs: [
      { label: "Formaat", value: "gem. ca. 20 × 10 cm" },
      { label: "Licht", value: "5V LED" },
    ],
    personalizable: true,
    personalization: "photo",
  },
];

export const seriesProductIds = ["dune", "flow", "bloom", "river", "tide", "lava"];
export const newArrivalIds = ["koraal", "bloom", "tide", "atoll", "strata", "sazanami", "naamcirkel", "lelievaas"];

export const heroSlides = [
  {
    productId: "koraal",
    eyebrow: "Nieuw — Koraal",
    heading: "Custom ontworpen. Met aandacht geproduceerd.",
    text: "Sculpturale designlampen, laag voor laag gemaakt in onze studio in Nederland.",
  },
  {
    productId: "bloom",
    eyebrow: "Bloom",
    heading: "Zacht licht, tussen de lagen door.",
    text: "Overlappende organische vormen die openen rond de lichtbron. In vijf kleuren.",
  },
  {
    productId: "tide",
    eyebrow: "Tide",
    heading: "Een landschap van licht en schaduw.",
    text: "Een rijk gelaagd reliëf, compleet geleverd met Italiaanse Creative-Cables voet.",
  },
];

export const priceBuckets = [
  { id: "tot-30", label: "Tot € 30", min: 0, max: 30 },
  { id: "30-60", label: "€ 30 – € 60", min: 30, max: 60 },
  { id: "60-plus", label: "€ 60 en hoger", min: 60, max: Infinity },
] as const;
